import { render } from "./tournament-teams.template.html?vue&type=template&id=4d1a1f98&scoped=true"
import script from "./TournamentTeams.vue?vue&type=script&lang=ts"
export * from "./TournamentTeams.vue?vue&type=script&lang=ts"

import "./TournamentTeams.vue?vue&type=style&index=0&id=4d1a1f98&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4d1a1f98"

export default script